import { inject, Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { SiteDistributionState, SiteDistributionStore } from '../site-distribution-store.service';

@Injectable({ providedIn: 'root' })
export class SiteDistributionQuery extends QueryEntity<SiteDistributionState> {
  protected store: SiteDistributionStore;

  constructor() {
    const store = inject(SiteDistributionStore);

    super(store);

    this.store = store;
  }
}
